"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var breakpoints = {
  mobileSmall: 320,
  mobile: 375,
  mobileLarge: 576,
  tablet: 768,
  tabletLarge: 1024,
  desktopSmall: 992,
  desktop: 1200,
  desktopLarge: 2100
};
var breakpointsBoostrap = {
  sm: breakpoints.mobileLarge,
  md: breakpoints.tablet,
  lg: breakpoints.desktopSmall,
  xl: breakpoints.desktop
};
var mediaQuery = {
  maxWidth: {
    mobileSmall: "@media (max-width:" + breakpoints.mobileSmall + "px)",
    mobile: "@media (max-width:" + breakpoints.mobile + "px)",
    mobileLarge: "@media (max-width:" + breakpoints.mobileLarge + "px)",
    tablet: "@media (max-width:" + breakpoints.tablet + "px)",
    tabletLarge: "@media (max-width:" + breakpoints.tabletLarge + "px)",
    desktopSmall: "@media (max-width:" + breakpoints.desktopSmall + "px)",
    desktop: "@media (max-width:" + breakpoints.desktop + "px)",
    desktopLarge: "@media (max-width:" + breakpoints.desktopLarge + "px)",
    bootstrap: {
      sm: "@media (max-width:" + (breakpointsBoostrap.sm - 0.2) + "px)",
      md: "@media (max-width:" + (breakpointsBoostrap.md - 0.2) + "px)",
      lg: "@media (max-width:" + (breakpointsBoostrap.lg - 0.2) + "px)",
      xl: "@media (max-width:" + (breakpointsBoostrap.xl - 0.2) + "px)"
    }
  },
  minWidth: {
    mobileSmall: "@media (min-width:" + breakpoints.mobileSmall + "px)",
    mobile: "@media (min-width:" + breakpoints.mobile + "px)",
    mobileLarge: "@media (min-width:" + breakpoints.mobileLarge + "px)",
    tablet: "@media (min-width:" + breakpoints.tablet + "px)",
    tabletLarge: "@media (min-width:" + breakpoints.tabletLarge + "px)",
    desktopSmall: "@media (min-width:" + breakpoints.desktop + "px)",
    desktop: "@media (min-width:" + breakpoints.desktop + "px)",
    desktopLarge: "@media (min-width:" + breakpoints.desktopLarge + "px)"
  },
  bootstrap: {
    sm: "@media (min-width:" + breakpointsBoostrap.sm + "px)",
    md: "@media (min-width:" + breakpointsBoostrap.md + "px)",
    lg: "@media (min-width:" + breakpointsBoostrap.lg + "px)",
    xl: "@media (min-width:" + breakpointsBoostrap.xl + "px)"
  }
};
exports.default = mediaQuery;